<template>
  <div class="home" v-if="challenge">
      <div class="data-header">
          <v-img
              :src="'/img/challenge/' + challenge.id + '/data_page.jpeg?kasi732'"
              class="grey lighten-2"
              style="width: 100%; height: 44.33%"
          >
              <template v-slot:placeholder>
                  <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                  >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
              </template>
          </v-img>
      </div>
    <div class="user-welcome-text text-sm-center pl-3 pr-3 py-2" v-html="message"></div>
    <evolt-notification v-if="!user.hideScan && evolt_data === 'not found'"></evolt-notification>
    <div v-if="!user.hideHR && leaderboard && leaderboard[0]">
      <v-layout align-center justify-center class="primary-title leaderboard-header">
        <h3>Leaderboard</h3>
      </v-layout>
      <v-layout align-center justify-space-between class="leaderboard-header">
        <h3 style="width: 50%;">Name</h3>
        <h3 style="width: 20%; text-align: center; padding: 0;">Score</h3>
        <h3 style="width: 27%; text-align: center; padding: 0;">Position</h3>
      </v-layout>
      <div style="position: relative; margin-bottom: 2px;" class="">
        <div id="leaderboard-container">
          <v-layout align-center justify-space-between v-for="(leader, position) in leaderboard" :key="position" class='leader' :class="{ 'leaderboard-sticker': leader.usrGUID === user.member_guid }">
            <h3 style="width: 50%;">{{ leader.firstname }} {{ leader.surname }}</h3>
            <h3 style="width: 20%; text-align: center;">{{ leader.score }}</h3>
            <h3 style="width: 27%; text-align: center;">{{ leader.pos }}</h3>
          </v-layout>
        </div>
      </div>
    </div>
    <check-list v-if="checklist && checklist.length > 0" class="my-3"></check-list>
    <div v-for="article in articles" class="featured-article">
      <v-img
              :src="article.image_url_full"
              aspect-ratio="1.7"
              class="grey lighten-2 mb-2"
              style="width: 100%; height: 70%;"
      >
        <template v-slot:placeholder>
          <v-layout
                  fill-height
                  align-center
                  justify-center
                  ma-0
          >
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-layout>
        </template>
      </v-img>
      <div class="featured-article-title-container">
        <div class="featured-article-title mr-5 ml-auto">
          <h3 >{{ article.title }}</h3>
          <router-link :to="'/advice/' + article.slug">Read More</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import { mapGetters } from 'vuex'
  import EvoltNotification from "../components/EvoltNotification";
  import CheckList from "../components/CheckList";
  require('../scripts/sticky-scroller')

  export default {
      beforeDestroy() {
          this.unwatch()
      },
      mounted () {

      var that = this

        this.unwatch = this.$store.watch(
            (state) => state.challenge.challenge,
            (newValue) => {
                if(newValue) that.setSticker()
            },{ deep: true }
        )
        setTimeout(() => {
          if (this.$store.state.challenge.challenge)
            that.setSticker()
        }, 500)



      this.$store.commit('articles/SET_ARTICLES', null)
      this.$store.dispatch('articles/loadArticles', true) // featured
      this.$store.dispatch('challenge/getLeaderboard')
      this.$store.dispatch('challenge/getChecklist')

      this.$store.watch(
          (state) => state.challenge.challenge,
            (newValue, oldValue) => {
              //console.log('watch', newValue, oldValue, this)

              this.setSticker()

            })
    },
    components: {
      CheckList,
        EvoltNotification
    },
    data: () => ({

      leaderboard_fake: [
        { firstname: 'Justin', surname: 'Brookes', score: 1, pos: 0, active: false },
        { firstname: 'Idrees', surname: 'Mcarthur', score: 2, pos: 0, active: false },
        { firstname: 'Justin', surname: 'Brookes', score: 3, pos: 0, active: false },
        { firstname: 'Rocky', surname: 'Park', score: 4, pos: 0, active: false },
        { firstname: 'Gurleen', surname: 'Valdez', score: 5, pos: 0, active: false },
        { firstname: 'Braden', surname: 'William', score: 6, pos: 0, active: false },
        { firstname: 'Andrei', surname: 'Dolan', score: 7, pos: 0, active: false },
        { firstname: 'Taybah', surname: 'Dalton', score: 8, pos: 0, active: false },
        { firstname: 'Zaid', surname: 'Le', score: 9, pos: 0, active: false },
        { firstname: 'Ellie', surname: 'Reeves', score: 10, pos: 0, active: false },
        { firstname: 'Juan', surname: 'Dixon', score: 11, pos: 0, active: false },
        { firstname: 'Ben', surname: 'Plain', score: 12, pos: 0, active: true, usrGUID: 'a0471728-415c-11e9-8d67-38eaa7381d5c' },
        { firstname: 'Rojin', surname: 'Galvan', score: 13, pos: 0, active: false },
        { firstname: 'Thalia', surname: 'Burks', score: 14, pos: 0, active: false },
        { firstname: 'Chelsea', surname: 'Bailey', score: 15, pos: 0, active: false },
        { firstname: 'Sarina', surname: 'Dickerson', score: 16, pos: 0, active: false },
        { firstname: 'Marlene', surname: 'Hurst', score: 17, pos: 0, active: false },
        { firstname: 'Natalia', surname: 'Hayes', score: 18, pos: 0, active: false },
        { firstname: 'Kaitlan', surname: 'Davison', score: 19, pos: 0, active: false },
        { firstname: 'Kasim', surname: 'Greig', score: 20, pos: 0, active: false },
        { firstname: 'Kiera', surname: 'Lang', score: 21, pos: 0, active: false },
        { firstname: 'Kory', surname: 'Daly', score: 22, pos: 0, active: false },
      ],
      cards: [
        { title: 'Your Weight', src: 'https://picsum.photos/200/300/?random', flex: 6 },
        { title: 'Your Lean Body Mass', src: 'https://picsum.photos/200/300/?random', flex: 6 },
        { title: 'Your Body Fat', src: 'https://picsum.photos/200/300/?random', flex: 6 },
        { title: 'Your Visceral Fat Level', src: 'https://picsum.photos/200/300/?random', flex: 6 }
      ]
    }),
    computed: {
      ...mapState({
        challenge: state => state.challenge.challenge,
        user: state => state.auth.user,
        articles: state => state.articles.posts,
        biometrics (state) { return this.biometrics_count > 0 ? state.data.evolt_data[this.current_biometrics] : null },
        biometrics_count: state => state.data.evolt_data ? state.data.evolt_data.length : 0,
        evolt_data: state => state.data.evolt_data,
        leaderboard: state => {
            return state.challenge.leaderboard
        }
      }),
      ...mapGetters({
          cutoffDays: 'challenge/cutoffDays',
          currentWeek: 'challenge/currentWeek',
          realWeek: 'challenge/realWeek'
      }),
      cssProps () {
        return {
          '--primary-color': this.$vuetify.theme.primary
        }
      },
      message () {
          if(!this.challenge) return null
        var message = this.challenge.message ? this.challenge.message : ''
        var results = message.match(/%([a-z_])*%/gi)
        var that = this

        if(results) {
          results.forEach(match => {
            var variable = match.replace(/%/g, '')
            message = message.replace(match, that.user[variable] && that.user[variable] !== 'undefined' ? that.user[variable] : '')
          })
        }
        return message
      },
      checklist () {
        return this.$store.state.challenge.checklist
      }
    },
    methods: {
      setSticker () {
        if(!this.leaderboard || !this.leaderboard[0]) return
        let div = document.getElementById('leaderboard-container')
        if(!div) return
        let sticker = document.getElementsByClassName('leaderboard-sticker')[0]
        if (this.leaderboard.length <= 6) return
        new window.StickyScroller(div, sticker)
      }
    },
    filters: {
      random (pos) {
        return Math.floor(1000 - (Math.random() * pos) + (pos + 1) * 50)
      }
    }
  }
</script>

<style scoped lang="scss">

  @import '../scss/variables';

  .home {
    //background: -moz-linear-gradient(left, rgba(47,173,186,0.2) 0%, rgba(43,159,171,0.2) 1%, rgba(0,0,0,0) 12%, rgba(0,0,0,0) 88%, rgba(47,173,186,0.2) 100%); /* FF3.6-15 */
    //background: -webkit-linear-gradient(left, rgba(47,173,186,0.2) 0%,rgba(43,159,171,0.2) 1%,rgba(0,0,0,0) 12%,rgba(0,0,0,0) 88%,rgba(47,173,186,0.2) 100%); /* Chrome10-25,Safari5.1-6 */
    //background: linear-gradient(to right, rgba(47,173,186,0.2) 0%,rgba(43,159,171,0.2) 1%,rgba(0,0,0,0) 12%,rgba(0,0,0,0) 88%,rgba(47,173,186,0.2) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    //filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#332fadba', endColorstr='#332fadba',GradientType=1 ); /* IE6-9 */
    width: 100%;
      min-height: calc(100vh - 100px);
      padding-bottom: 30px;
      .user-welcome-text {
          text-align: center;
      }
  }

  .leaderboard-header {
    height: 27px;
    width: 100%;
    background: #000000;
    border-bottom: solid 1px #FFFFFF;
    h3 {
      color: #FFFFFF;
      padding: 0 15px;
      text-transform: uppercase;
      font-weight: bold;
      margin: 0;
      line-height: 0;
      font-size: 14px;
    }
  }

  #leaderboard-container {
    font-size: 14px;
    color: #FFFFFF;
    height: 115px;
    overflow-x: hidden;
    overflow-y: scroll;
    background: grey;
    width: 100%;
    background: #000000;
    p {
      height: 23px;
      margin: 0;
      display: block;
      background: #8a4182;
    }
    .leader {
      height: 23px;
      width: 100%;
      h3 {
        padding: 0 15px;
        font-weight: normal;
        line-height: 0;
        font-size: 14px;
        text-transform: uppercase;
      }
    }
    .leaderboard-sticker {
      background: $primary;
    }

  }
  .featured-article {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    &-title-container {
      width: 100%;
      background: rgba(0,0,0,.5);
      position: absolute;
      bottom: 10px;
      display: flex;
    }
    &-title {
      padding: 10px;
      margin: auto;
      text-align: right;
      h3 {
        font-family: 'DIN Alternate Bold';
        text-transform: uppercase;
        color: #FFFFFF;
        font-size: 20px;
        margin: 15px 0 5px;
        line-height: 0;
      }
      a {
        margin-top: 0;
        font-size: 12px;
        text-decoration: none;
        text-transform: uppercase;
        font-weight: bold;
      }
    }

  }
</style>
